import React from 'react';
import PropTypes from 'prop-types';
import {
  Toolbar,
  IconButton,
  Divider,
  Typography,
  Box,
} from '@material-ui/core';
import RipleyIcon from '../../common/icons/regular/RipleyIcon';
import { useHeaderMainStyles } from './styles';
import { simple } from '../../../config/paths';
const HeaderMain = ({ ...props }) => {
  const { mobile } = props;
  const classes = useHeaderMainStyles({ mobile });

  return (
    <Toolbar>
      <IconButton edge="start" onClick={() => window.open(simple, '_blank')}>
        <RipleyIcon />
      </IconButton>
      <Divider className={classes.divider} orientation="vertical" />
      <Box marginLeft="20px">
        <Typography className={classes.typo}>Mensaje Directo</Typography>
      </Box>
    </Toolbar>
  );
};

HeaderMain.propTypes = {
  mobile: PropTypes.bool,
};

export default HeaderMain;
